// eslint-disable-next-line
// the data is coming from https://docs.google.com/spreadsheets/d/1FLO9r85sqESXzfZI79KFuV2wiG1HYpOHpIBvvyIElqA/edit#gid=283606502
// if the values will be changes, we need to change it here as well
export const categoryMapper = {
  ADULT_SHOES_AND_CLOTHING: 'Adult Shoes & Clothing',
  AUTOMOTIVE_PARTS_AND_ACCESSORIES: 'Automotive Parts & Accessories',
  BAGS_AND_WALLETS: 'Bags & Wallets',
  BODY_AND_HAIR_CARE: 'Body & Haircare',
  BOOK_AND_MAGAZINES: 'Books & Magazines',
  CANDY: 'Candy',
  CAR_ELECTRONICS: 'Car Electronics',
  CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS: 'Children Clothes & Nurturing Products',
  CHILDREN_TOYS: 'Children Toys',
  CLEANING_AND_SANITARY: 'Cleaning & Sanitary',
  COLLECTIBLES: 'Collectibles',
  CONCEPT_STORES_AND_MISCELLANEOUS: 'Concept Stores & Miscellaneous',
  COSMETICS: 'Cosmetics',
  COSTUMES_AND_PARTY_SUPPLIES: 'Costumes & Party Supplies',
  DATING_SERVICES: 'Dating Services',
  DECORATION_AND_ART: 'Decoration & Art',
  DIETARY_SUPPLEMENTS: 'Dietary Supplements',
  DIGITAL_SERVICES: 'Digital Services',
  DIVERSIFIED_CHILDREN_PRODUCTS: 'Diversified Children Products',
  DIVERSIFIED_ELECTRONICS: 'Diversified Electronics',
  DIVERSIFIED_ENTERTAINMENT: 'Diversified Entertainment',
  DIVERSIFIED_EROTIC_MATERIAL: 'Diversified Erotic Material',
  DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS: 'Diversified Jewelry & Accessories',
  DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS: 'Diversified Health & Beauty Products',
  DIVERSIFIED_JEWELRY_AND_ACCESSORIES: 'Diversified Home & Garden Products',
  EDUCATION: 'Education',
  ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES: 'Electronic Equipment & Related Accessories',
  EROTIC_CLOTHING_AND_ACCESSORIES: 'Erotic Materials', // this category is mapped to the group
  EVENT_TICKETS: 'Event Tickets',
  FOOD_AND_BEVERAGE: 'Food & Beverage',
  FRAGRANCES: 'Fragrances',
  FURNITURE: 'Furniture',
  GENERAL_SHOES_AND_CLOTHING: 'General Shoes & Clothing',
  HOBBY_ARTICLES: 'Hobby Articles',
  HOUSEHOLD_ELECTRONICS: 'Household Electronics (Whitegoods/Appliances)',
  JEWELRY_AND_WATCHES: 'Jewelry & Watches',
  KITCHENWARE: 'Kitchenware',
  MARKETPLACES: 'Marketplaces',
  MUSIC_AND_MOVIES: 'Music & Movies',
  MUSICAL_INSTRUMENTS_AND_EQUIPMENT: 'Musical Instruments & Equipment',
  NON_PRESCRIPTION_SUNGLASSES_AND_LENSES: 'Non-Prescription Sunglasses & Contact Lenses',
  OFFICE_MACHINES_AND_RELATED_ACCESSORIES:
    'Office Machines & Related Accessories (Excl. Computers)',
  OTHER_SERVICES: 'Other Services',
  PERSONAL_CARE_AND_BODY_IMPROVEMENT: 'Personal Care & Body Improvement',
  PET_SUPPLIES: 'Pet Supplies',
  PHARMACEUTICAL_PRODUCTS: 'Pharmaceutical Products',
  PLANTS_AND_FLOWERS: 'Plants & Flowers',
  PRESCRIPTION_OPTICS: 'Prescription Optics',
  PRINTS_AND_PHOTOS: 'Prints & Photos',
  SAFETY_PRODUCTS: 'Safety Products',
  SEX_TOYS: 'Sex Toys',
  SPORTS_GEAR_AND_OUTDOOR: 'Sports Gear & Outdoor',
  TOBACCO: 'Tobacco',
  TOOLS_AND_HOME_IMPROVEMENT: 'Tools & Home Improvement',
  TRAVEL_SERVICES: 'Travel Services',
  UNDERWEAR: 'Underwear',
  VIDEO_GAMES_AND_RELATED_ACCESSORIES: 'Video Games & Related Accessories',
  WHEELS_AND_TIRES: 'Wheels & Tires',
  WINE_BEER_AND_LIQUOR: 'Wine, Beer & Liquor',
  YOUTHFUL_SHOES_AND_CLOTHING: 'Youthful Shoes & Clothing',
  GAMBLING_BETTING_CASINOS_AND_LOTTERY: 'Gambling, Betting, Casinos & Lottery',
  CHARITIES_AND_NGO: 'Charities and NGO services',
  EROTIC_SERVICES: 'Erotic services',
  FINANCIAL_SERVICES_CRYPTO: 'Financial services - Crypto-related activities',
  FINANCIAL_SERVICES_MSB: 'Financial services - Money Service Business',
  FINANCIAL_SERVICES_E_WALLETS: 'Financial services - E-wallets',
  FINANCIAL_SERVICES_TRADING: 'Financial services - Trading',
  SOCIAL_PLATFORMS_COMMUNITIES: 'Social platform communities',
  TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS: 'Travel - Air Travel & Cruise Operators',
  TRAVEL_BROKER_AND_AGENCIES: 'Travel - Broker & Agencies',
  TRAVEL_GROUND_TRANSPORTATION: 'Travel - Ground Transportation',
  TRAVEL_ACCOMMODATION_AND_RESORTS: 'Travel - Accommodation & Resorts',
  EVENT_ORGANIZER: 'Event - Organizer',
  EVENT_BROKER_AND_AGENCIES: 'Event - Broker & Agencies',
};

export const groupMapper = {
  AUTOMOTIVE_PRODUCTS: 'Automotive Products',
  CHILDREN_PRODUCTS: 'Children Products',
  CLOTHING_AND_SHOES: 'Clothing & Shoes',
  EROTIC_MATERIALS: 'Erotic Materials',
  FOOD_AND_BEVERAGE: 'Food & Beverage',
  HEALTH_AND_BEAUTY: 'Health & Beauty',
  HOME_AND_GARDEN: 'Home & Garden',
  INTANGIBLE_PRODUCTS: 'Intangible products',
  JEWELRY_AND_ACCESSORIES: 'Jewelry & Accessories',
  LEISURE_SPORT_AND_HOBBY: 'Leisure, Sport & Hobby',
  NOT_APPLICABLE: 'Not Applicable',
  ELECTRONICS: 'Electronics',
  ENTERTAINMENT: 'Entertainment',
  RETAIL: 'Retail',
  UNKNOWN: 'Unknown',
};
